/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["video-preview{display:block;max-width:80%;max-height:80%;height:auto}@media only screen and (max-width:768px){video-preview{width:90%}}video-preview video{display:block;max-width:100%;max-height:100%;height:auto;margin:auto;box-shadow:0 3px 3px -2px rgba(0,0,0,.2),0 3px 4px 0 rgba(0,0,0,.14),0 1px 8px 0 rgba(0,0,0,.12);position:absolute;top:0;left:0;right:0;bottom:0}video-preview default-preview{margin:auto;position:absolute;top:0;left:0;right:0;bottom:0}"];
export { styles as styles };
